import { Component, ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams, Slides } from 'ionic-angular';
import { TabsPage } from '@pages';
import { AuthProvider } from '@providers/auth/auth';

@IonicPage()
@Component({
  selector: 'page-onboarding',
  templateUrl: 'onboarding.html',
})
export class OnboardingPage {

  @ViewChild(Slides) slides: Slides;


  constructor(
    public navCtrl: NavController, 
    public navParams: NavParams,
    private authProvider: AuthProvider,
  ) {
  }

  ionViewDidLoad() {
  }

  next() {
    if(this.slides.isEnd() ) {
      this.authProvider.ocultaOnboarding();
      this.navCtrl.setRoot(TabsPage)
    } else {
      this.slides.slideNext();
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/onboarding/onboarding.ts